import { useState, useEffect } from "react";
import HelperLogin from "./HelperLogin";
import HelperDashboard from "./HelperDashboard";

const HelperPortal = () => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem("helper_session");
    if (saved) {
      try {
        setSession(JSON.parse(saved));
      } catch (e) {
        localStorage.removeItem("helper_session");
      }
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-[#00C2FF] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!session) {
    return <HelperLogin onLogin={setSession} />;
  }

  return (
    <HelperDashboard
      session={session}
      onLogout={() => {
        localStorage.removeItem("helper_session");
        setSession(null);
      }}
    />
  );
};

export default HelperPortal;
